import { EParkingType, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectParkingFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const ParkingContainer: FC = () => {
  const { label, value, options } = useSelector(selectParkingFilter);

  const onChange = useFilterChangeCallback();

  const handleParkingTypesChange = useCallback(
    (newValue: NonEmptyArray<EParkingType> | null) => {
      onChange({ action: 'setParkingType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleParkingTypesChange} />
    </AdvancedFilterRow>
  );
};
